<template>
	<page>
		<module :title="id ? '编辑发放任务' : '新建发放任务'">
			<c-form ref="form">
				<c-form title="基础信息">
                    <c-form-item type="radio" label="任务类型" value="0"  name="task_type" v-model="taskType" :options="taskTypeOptions" required word="自行领取优惠券任务默认对所有用户可见" ></c-form-item>
					<c-form-item type="input" label="任务名称" name="task_name" required></c-form-item>
                    <c-form-item v-if="taskType == 0" type="radio" label="目标用户" required
                                 v-model="taskUserType" name="task_user_type"
                                 :options="taskUserOptions" word="发放全部普通用户将以执行发放时的用户为准,仅会发放给启用状态的普通用户，经销商不发放"></c-form-item>
                    <c-form-item  v-if="taskType == 0 && taskUserType==2">
                        <m-operate>
							<c-button color="gray" hollow @click="$refs.memberSelector.open(-99)">添加用户</c-button>
						</m-operate>
						
						<c-table ref="memberList" v-model="memberList" height="300" :paging="false" border>
							<c-table-column
								label="手机号"
								name="user_manage_mobilephone"
							></c-table-column>
							
							<c-table-column
								label="昵称"
								name="nick_name"
							></c-table-column>
							
							<c-table-column
								type="button"
								fixed="right"
								label="操作"
							>
								<template v-slot="row">
									<c-table-button @click="row.remove()">删除</c-table-button>
								</template>
							</c-table-column>
						</c-table>
					</c-form-item>
				</c-form>
				<c-form title="发放策略">
					<c-form-item label="选择优惠券" required>
						<m-operate>
							<c-button color="gray" hollow @click="$refs.couponSelector.open()">添加优惠券</c-button>
						</m-operate>
						
						<c-table ref="couponList" v-model="couponList" height="auto" :paging="false" border>
							<c-table-column
								label="优惠券名称"
								name="coupon_name"
								width="120"
							></c-table-column>
							
							<c-table-column
								label="优惠力度"
								name="detail"
								width="120"
							></c-table-column>
							
							<c-table-column
								label="适用范围"
								name="commodity_range"
								width="70"
							>
								<template v-slot="{data}">
									{{dict.couponRange[data.commodity_range]}}
								</template>
							</c-table-column>
							
							<c-table-column
								label="剩余可领"
								name="surplus"
								width="70"
							></c-table-column>
							
							<c-table-column
								required
								label="有效期"
								width="310"
							>
								<template v-slot="row">
									<span v-if="row.data.valid_date_type" style="margin-right: 5px;">{{row.data.valid_date_type == 1 ? `${row.data.valid_start_date} - ${row.data.valid_end_date}` : `领取后${row.data.effective_days}天内`}}</span>
									<a class="s-link" @click="setValidDate(row)">编辑</a>
								</template>
							
							</c-table-column>
							
							<c-table-column
								required
								label="每人限领"
								width="80"
							>
								<template v-slot="row">
									<c-input v-model="row.data.received_count" type="number"></c-input>
								</template>
							</c-table-column>
							
							<c-table-column
								label="券标签"
								width="80"
							>
								<template v-slot="row">
									<c-input v-model="row.data.coupon_tag" maxlength="5"></c-input>
								</template>
							</c-table-column>
							
							<c-table-column
								type="button"
								fixed="right"
								label="操作"
								width="100"
							>
								<template v-slot="row">
									<c-table-button @click="row.remove()">删除</c-table-button>
								</template>
							</c-table-column>
						</c-table>
					</c-form-item>
					<c-form-item v-model="sendDate" v-if="taskType == 0" type="radio" label="发放时间" name="execute_type" :options="sendDateOptions" required></c-form-item>
					<c-form-item v-show="sendDate == 2" v-if="taskType == 0" type="datetime" name="scheduled_execute_date"></c-form-item>
					<c-form-item type="textarea" label="备注" name="remark"></c-form-item>
				</c-form>
			</c-form>
			<template slot="button">
				<c-button size="m" @click="submit(1)">确定提交</c-button>
				<c-button size="m" hollow @click="submit(0)">暂存草稿</c-button>
			</template>
		</module>
		<member-selector ref="memberSelector" multiple @resolve="selectHandle($event, 'memberList', 'platform_user_id')"></member-selector>
		<coupon-selector ref="couponSelector" multiple @resolve="selectHandle($event, 'couponList', 'id')"></coupon-selector>
		<c-dialog ref="validDateDialog" title="设置有效期" width="500" height="200" @resolve="setValidDateHandle">
			<c-form ref="validDateForm">
				<c-form-item v-model="validDate" type="radio" :label="false" name="valid_date_type" :options="validDateOption" required></c-form-item>
				<c-form-item v-show="validDate == 1" type="datetime" :label="false" start-name="valid_start_date" end-name="valid_end_date"></c-form-item>
				<c-form-item v-show="validDate == 2" :label="false">
					<c-input v-model="days" type="number" decimal="2" width="135" height="38" word="天"></c-input>
				</c-form-item>
			</c-form>
		</c-dialog>
	</page>
</template>

<script>
	import memberSelector from '@/components/service/member_selector.vue'
	import couponSelector from '@/components/service/coupon_selector.vue'
	import {mapState} from 'vuex'
	
	export default {
		name: 'coupon_task_edit',
		
		components: {
			memberSelector, couponSelector
		},
		
		props: {
			id: String
		},
		
		data() {
			return {
				sendDate: 1,
		        taskTypeOptions: [
		          {name: '自动发放',value: 0},
		          {name: '自行领取',value: 1}
		        ],
                taskUserOptions: [
		          {name: '全部用户',value: 0},
		          {name: '手动选择',value: 2}
		        ],
                taskUserType: 2,
		        taskType: 0,
		        sendDateOptions: [{
					name: '立即发放',
					value: 1
				}],
				memberList: [],
				couponList: [],
				
				validDate: 1,
				validDateOption: [{
					name: '固定时间',
					value: 1
				}, {
					name: '领取后',
					value: 2
				}],
				days: ''
			}
		},
		
		computed: {
			...mapState(['dict'])
		},
		
		watch: {
			id() {
				this.getTaskDetail();
			}
		},
		
		mounted() {
			this.id && this.getTaskDetail();
		},
		
		methods: {
			getTaskDetail() {
				this.request({
					url: '/couponInfo/task/detail',
					data: {
						id: this.id
					},
					loading: true,
					success: data => {
						this.$refs.form.set(data);
						this.taskUserType = data.task_user_type || 2;
						this.memberList = data.user_list || [];
						this.couponList = data.coupon_list || [];
					}
				});
			},
			
			selectHandle(list, ref, key) {
				list = list.filter(item => {
					return !this[ref].find(row => {
						return row[key] == item[key];
					});
				});
				this[ref] = this[ref].concat(list);
			},
			
			setValidDate(item) {
				this._edit = item;
				this.$refs.validDateForm.clear();
				this.validDate = 1;
				this.days = item.data.effective_days || '';
				this.$refs.validDateForm.set(item.data);
				this.$refs.validDateDialog.open();
			},
			
			setValidDateHandle(stop) {
				stop();
				this.$refs.validDateForm.submit({
					local: true,
					
					rule: {
						valid_start_date: [{
							type: 'empty',
							skip: () => {
								return this.validDate == 2;
							},
							word: '请选择有效期范围'
						}],
						days: [{
							type: 'function',
							fun: () => {
								return !!this.days;
							},
							skip: () => {
								return this.validDate == 1;
							},
							word: '请填写有效期'
						}]
					},
					
					success: data => {
						data.effective_days = this.days;
						this._edit.update(data);
						this.$refs.validDateDialog.close();
					}
				})
			},
			
			submit(state) {
				this.$refs.form.submit({
					url: this.id ? '/couponInfo/task/edit' : '/couponInfo/task/add',
					
					rule: {
						task_name: '请填写发放任务名称',
						member_list: [{
							type: 'function',
							fun: () => {
								return !!this.memberList.length;
							},
                            skip: () => {
                                return this.taskType == 1 || this.taskUserType == 0;
                            },
							word: '请选择目标用户'
						}],
						coupon_list: [{
							type: 'function',
							fun: () => {
								return !!this.couponList.length;
							},
							word: '请选择优惠券'
						}],
						coupon_config: [{
							type: 'function',
							fun: () => {
								return !this.couponList.find(item => {
									return !item.valid_date_type || !item.received_count;
								});
							},
							word: '请设置优惠券有效期及限领张数'
						}],
						scheduled_execute_date: [{
							type: 'empty',
							skip: () => {
								return this.taskType ==1 || this.sendDate != 2;
							},
							word: '请选择发放时间'
						}]
					},
					
					dataFormatter: data => {
						this.id && (data.id = this.id);
						data.state = state;
						data.task_user_type = this.taskUserType;
						if (this.taskType==0){
                          data.user_list = Array.from(this.memberList, item => {
                            return {
                              platform_user_id: item.platform_user_id
                            }
                          });
                        }
						data.coupon_list = Array.from(this.couponList, item => {
							return {
								coupon_id: item.id,
								valid_date_type: item.valid_date_type,
								valid_start_date: item.valid_start_date,
								valid_end_date: item.valid_end_date,
								effective_days: item.effective_days,
								received_count: item.received_count,
								coupon_tag: item.coupon_tag
							}
						});
						return data;
					},
					
					success: () => {
						this.$message({
							text: '保存成功'
						});
						this.$bus.$emit('couponTaskList.update');
						this.redirectTo('/coupon_task');
					}
				})
			}
		}
	}
</script>